// Shown while auth and organization context resolve, so a slow bootstrap
// reads as "loading" rather than a blank page.
const BootSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
  </div>
);

export default BootSpinner;
